import { Component, inject } from '@angular/core';
import { FooterNavigationComponent } from './footer-navigarion/footer-navigation.component';

import { CmsFacade, SlotDecoratorDirective } from '@boels/shared-state';
import { Observable, map } from 'rxjs';
import { CmsNavigationComponent, ContentSlot } from '@boels/models';
import { AsyncPipe } from '@angular/common';

@Component({
  imports: [FooterNavigationComponent, SlotDecoratorDirective, AsyncPipe],
  selector: 'boels-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  private cmsFacade = inject(CmsFacade);

  footerSlot$: Observable<ContentSlot | undefined> =
    this.cmsFacade.getFooterData();

  componentData$: Observable<CmsNavigationComponent> = this.footerSlot$.pipe(
    map((slot) => slot?.components?.component?.[0]?.navigationNode),
  );
}
